import * as React from 'react';
import { FaqItem } from '@grandvisionhq/content';
import { PopupModal } from '../PopupModal/PopupModal.js';

const AppointmentFaq = ({ title , faqItems , isOpen , onModalClose  })=>{
     return React.createElement(PopupModal, {
        className: "appointment-faq",
        title: title,
        isOpen: isOpen,
        showIcon: true,
        onModalClose: onModalClose
    }, faqItems === null || faqItems === void 0 ? void 0 : faqItems.map(({ id , question , answer  })=>/*#__PURE__*/ React.createElement(FaqItem, {
            id: id,
            question: question,
            answer: answer,
            key: id,
            appendIdToUrl: false
        })
    ));
};

export { AppointmentFaq as default };
//# sourceMappingURL=AppointmentFaq.js.map
